export default "__VITE_ASSET__CDkKhjY7__"